import store from '@/vuex'
export function hasAuthLogin(topath){
     const whiteUrlList=['login','404']
     if(!whiteUrlList.includes(topath) && (store.state.user.token==''||store.state.user.token==undefined||store.state.user.myroutes.length<=0)){
         return false
     }else{
         return true
     }
}

export function doLogout(){
     store.commit("LOG_OUT")
}